/* ═══════════════════════════════════════════════════════
   MARAUDER — iOS Scroll-Lock für Drawer
   Dawn sperrt beim Öffnen nur mit overflow:hidden am body.
   iOS Safari ignoriert das: die Seite dahinter scrollt weiter,
   Safaris Leiste klappt ein und aus, der Viewport ändert seine
   Höhe und fixierte Elemente wackeln.
   Hier wird der body echt festgesetzt (position:fixed) und die
   Scrollposition beim Schliessen wiederhergestellt.
   Nur <= 749px aktiv. Rollback: Datei löschen + Zeile in
   theme.liquid entfernen (MARAUDER IOS SCROLL LOCK).
═══════════════════════════════════════════════════════ */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var body = document.body;
  var y = 0;
  var locked = false;

  function lock() {
    if (locked || !mq.matches) return;
    y = window.pageYOffset || document.documentElement.scrollTop || 0;
    body.style.position = 'fixed';
    body.style.top = (-y) + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    locked = true;
  }

  function unlock() {
    if (!locked) return;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    window.scrollTo(0, y);
    locked = false;
  }

  function sync() {
    body.classList.contains('overflow-hidden') ? lock() : unlock();
  }

  new MutationObserver(sync).observe(body, { attributes: true, attributeFilter: ['class'] });
  sync();

  /* Beim Wechsel auf Desktop-Breite nicht gesperrt haengen bleiben */
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () {
    if (!mq.matches) unlock();
  });
}());
